function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

import bind from "./bind";
import createFormComponent from "./createFormComponent";
import * as utils from "./utils";
import ajax from './ajax';
export function optionFieldsMap(option, fieldNames) {
  var defaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    readOnly: false,
    disabled: false
  };

  if (_typeof(option) !== "object") {
    option = {
      value: option,
      label: option
    };
  }

  var _option = option,
      title = _option.title,
      label = _option.label,
      _option$disabled = _option.disabled,
      disabled = _option$disabled === void 0 ? false : _option$disabled,
      _option$readOnly = _option.readOnly,
      readOnly = _option$readOnly === void 0 ? false : _option$readOnly;
  return utils.objectMap(Object.assign({}, defaults, option, {
    label: title || label,
    readOnly: readOnly || defaults.readOnly,
    disabled: disabled || defaults.disabled
  }), fieldNames);
}
export function optionsFieldsMap(options, fieldNames, defaults, filter) {
  return options.map(function (option) {
    var value = optionFieldsMap(option, fieldNames, defaults);
    return filter ? filter(value) : value;
  });
}

var _default = _objectSpread(_objectSpread({}, bind), {}, {
  createFormComponent: createFormComponent,
  utils: utils,
  ajax: ajax
});

window.SUI = {
  Util: utils,
  ajax: ajax
};
export default _default;